











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import CloseBtn from '@share/common/CloseBtn.vue';
import CreateForm from "./form/PartnerCreateForm.vue";

import { PartnerCreateService } from "@share/catalog/services/admin/PartnerCreateService";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { PartnerCreateModel } from "@api/models/exhibition/PartnerCreateModel";
import { UserProfile } from "@api/models/UserProfile";
import PeopleSelect from "@share/common/form/form-controls/select/people-select/PeopleSelect.vue";
import BackButton from "@service/components/common/back-button/BackButton.vue";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { FileRepository } from "@api/repositories/FileRepository";
import { UnloadService } from "@share/common/services/unloadService/UnloadService";
import { settingsActionsLists } from "@service/store/settings/actions-list";

@Component({
    components: {
        CloseBtn, CreateForm, PeopleSelect, BackButton
    }
})

export default class PartnerCreate extends Vue {

    @Prop({ required: true }) tagSchemaId: string;
    @Prop({ required: true }) schemaId: string;
    @Prop({ default: false }) closeOnSave: boolean;

    showUserSelect = false;
    owners: UserProfile[] = [];

    createModel: PartnerCreateModel | null = null;

    creatingService: PartnerCreateService;
    unloadService: UnloadService | null = null;

    resetable = false;

    async created() {

        this.unloadService = new UnloadService(this, "resetable", this.$t('agenda.form.goBackConfirmation').toString());

        const languages = await this.$store.dispatch(settingsActionsLists.loadLanguages);

        this.creatingService = Vue.observable(new PartnerCreateService(
            this.schemaId,
            this.$repositories.get(RepositoryFabric.OBJECT) as ObjectRepository,
            this.$repositories.get(RepositoryFabric.FILE) as FileRepository,
            languages
        ));

        this.createModel = Vue.observable(new PartnerCreateModel(this.langList, this.eventId));
    }

    async close() {
        if(this.resetable) {
            const confirmed = await this.unloadService?.trigger();

            if(confirmed) {
                this.$emit('close')
            }
        }
        else {
            this.$emit('close');
        }
    }

    afterSave() {
        this.createModel?.resetCopy();
        this.resetable = !!this.createModel?.needReset;
        if (this.closeOnSave) {
            this.close();
        }
    }

    @Watch('createModel', { deep: true })
    watchSession() {
        this.resetable = !!this.createModel?.needReset;
    }

    beforeDestroy() {
        this.unloadService?.unsubscribe();
    }

    get langList(): string[] {
        return this.creatingService?.languages || [];
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get eventId(): string {
      return this.$store.state.events.selected;
    }
}

